import React, { useState } from 'react'
import Classes from './styles/style.module.css'
import Navbar from '../Home/Components/Navbar/Navbar'
import Footer from '../../GlobalComp/Footer/Footer';

export default function PrivacyPolicy() {

    return (
        <>
            <form className={Classes.hero} >

                <Navbar />
                <div className={Classes.heroContent} >
                    <div className={Classes.heading}>
                        <h1>Privacy Policy</h1>
                    </div>
                    <h5>Effective Date: April 28th, 2025</h5>
                    <br />
                    <h5>
                        Welcome to <a href='/' target='_blank' >mentr.com</a>  ("mentr," "we," "us," or "our"). This Privacy Policy explains how we collect, use, and protect your information when you use our website, platform, products, and services (collectively, the "Services").
                        <br />
                        <br />
                        By using the Services, you agree to the practices described in this Privacy Policy.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>1. Information We Collect </h5>
                    <h5>
                        We collect several types of information to provide and improve our Services:
                    </h5>
                    <br />

                    <h5 className={Classes.mini_title}>a. Information You Provide:</h5>
                    <ul>
                        <li>
                            <h5>
                                Account registration details such as name, email address, and company information
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Client and project information you upload to the platform
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Payment details, processed through secure third-party providers
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Communications sent to us, including support requests and feedback
                            </h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.mini_title}>b. Information We Collect Automatically:</h5>
                    <ul>
                        <li>
                            <h5>
                                Device and browser information such as IP address, browser type, and operating system
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Usage data such as pages visited, time spent on the platform, and user activity</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.mini_title}>c. Information from Third Parties:</h5>
                    <ul>
                        <li>
                            <h5>
                                Information received from third-party services you integrate with mentr.com, such as payment processors or CRM systems</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>2. How We Use Your Information</h5>
                    <h5>We use your information to:</h5>
                    <br />

                    <ul>
                        <li>
                            <h5>
                                Provide, operate, and improve the Services
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Process transactions and manage your subscription
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Communicate with you about your account and updates to our Services
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Analyze usage trends to improve the platform
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Detect, prevent, and address technical issues, fraud, or security breaches
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Comply with legal obligations
                            </h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>3. How We Share Your Information</h5>
                    <h5>We do not sell your personal information.
                        <br /> We may share your information with:
                    </h5>
                    <br />

                    <ul>
                        <li>
                            <h5>
                                Service providers who perform services on our behalf (such as hosting, customer support, and payment processing)
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Legal authorities if required by law or to protect our rights
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Third parties with your explicit consent or direction
                            </h5>
                        </li>
                    </ul>

                    <br />
                    <h5 className={Classes.major_title}>4. Data Security</h5>
                    <h5>
                        We implement appropriate technical and organizational measures to safeguard your information. However, no system is completely secure, and we cannot guarantee absolute security.
                        <br />You are responsible for keeping your account credentials safe.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>5. Data Retention</h5>
                    <h5>
                        We retain your information as long as your account is active or as needed to provide the Services. We may retain information for longer periods if necessary to comply with legal obligations, resolve disputes, or enforce our agreements.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>6. Your Rights and Choices</h5>
                    <h5>
                        Depending on your location, you may have rights to:
                    </h5>
                    <br />

                    <ul>
                        <li>
                            <h5>
                                Access, correct, or delete your personal information
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Object to or restrict certain types of processing
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Withdraw consent where applicable
                            </h5>
                        </li>
                    </ul>

                    <br />
                    <h5>
                        To exercise your rights, please contact us at Support@mentr.com.
                    </h5>

                    <br />
                    <h5 className={Classes.major_title}>7. Third-Party Services</h5>
                    <h5>
                        Our Services may contain links to third-party websites or integrations with third-party services. We are not responsible for the privacy practices or content of third parties. We encourage you to review their privacy policies.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>8. Children's Privacy</h5>
                    <h5>
                        mentr.com is not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>9. Changes to This Privacy Policy</h5>
                    <h5>
                        We may update this Privacy Policy from time to time. If we make material changes, we will notify you through the Services or by other means.
                        <br />Your continued use of the Services after changes become effective constitutes your acceptance of the updated Privacy Policy.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>10. Contact Us</h5>
                    <h5>
                        If you have any questions about this Privacy Policy, please contact us at:
                        <br /><br />
                        mentr.com
                        <br />
                        Support@mentr.com
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>11. Governing Law</h5>
                    <h5>
                        This Privacy Policy shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law principles.
                    </h5>
                    <br />

                </div>

            </form>
            <Footer />
        </>
    )
}
